import type { NewsItem } from "@/types/movie";

export const newsList: NewsItem[] = [
  {
    id: "news-1",
    title: "《星际迷航：黎明》口碑爆棚，被誉为年度最佳科幻片",
    date: "2026-10-13",
    category: "影视资讯",
    excerpt:
      "上映首周末即斩获票房冠军，观众盛赞其宏大的宇宙想象与细腻的人物刻画，多家媒体给出接近满分的评价。",
  },
  {
    id: "news-2",
    title: "2026 秋季档剧集前瞻：五部值得追的高口碑新剧",
    date: "2026-10-11",
    category: "追剧指南",
    excerpt:
      "从悬疑犯罪到太空歌剧，本季度新剧类型丰富。我们整理了一份片单，帮你快速锁定最值得期待的几部作品。",
  },
  {
    id: "news-3",
    title: "国产年代剧再掀热潮，《江南往事》为何如此动人",
    date: "2026-10-09",
    category: "深度解读",
    excerpt:
      "以一座水乡、一个家族为主线，《江南往事》用细腻的笔触还原时代变迁，被观众称为「可以慢慢品的剧」。",
  },
  {
    id: "news-4",
    title: "动画电影《寻梦环球》票房破纪录，合家欢题材持续升温",
    date: "2026-10-05",
    category: "票房速递",
    excerpt:
      "精良的手绘风格与温暖的成长故事，让这部作品成为今年最受欢迎的合家欢电影之一，周边产品同样热销。",
  },
];

export const siteIntro =
  "天天影院是一个专注最新热门电影与电视剧的影视内容平台。我们汇集海量影视资料，提供清晰的剧情介绍、专业的影片推荐与及时的影视资讯，帮助你轻松发现值得一看的好作品。无论你是科幻迷、悬疑控还是追剧达人，都能在这里找到属于自己的光影世界。";